import { NumberInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { VehicleFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function VehicleFormExtended() {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<VehicleFormSchema>();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<NumberInput
				isRequired={false}
				control={methods.control}
				name="maximumLoadKg"
				min={0}
				label={t("vehicles.maximum_load_kg")}
				placeholder="0"
				variant="kilogram"
			/>
		</div>
	);
}
